"use client";

import { motion } from "motion/react";
import { Sprite } from "./sprite";

const DECOS = [
  { name: "idle",    top: "22%", left:  "1.8%", rotate: -8,  scale: 0.38, delay: 0.0, startFrame: 0  },
  { name: "trophy",  fw: 162, top: "33%", right: "1.5%", rotate:  9,  scale: 0.40, delay: 0.2, startFrame: 14 },
  { name: "lift",    top: "46%", left:  "2.2%", rotate: -12, scale: 0.35, delay: 0.4, startFrame: 7  },
  { name: "loading", top: "57%", right: "2.0%", rotate:  6,  scale: 0.36, delay: 0.1, startFrame: 3  },
  { name: "idle",    top: "68%", left:  "1.5%", rotate: 10,  scale: 0.42, delay: 0.3, startFrame: 11 },
  { name: "trophy",  fw: 162, top: "78%", right: "1.8%", rotate: -7,  scale: 0.38, delay: 0.5, startFrame: 17 },
  { name: "lift",    top: "88%", left:  "2.5%", rotate: 14,  scale: 0.34, delay: 0.6, startFrame: 5  },
] as const;

export function DecoLayer() {
  return (
    <div className="deco-layer" aria-hidden="true">
      {DECOS.map((d, i) => (
        <motion.div
          key={i}
          className="deco-item"
          style={{
            top: d.top,
            left: (d as { left?: string }).left,
            right: (d as { right?: string }).right,
            transform: `rotate(${d.rotate}deg)`,
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.5 + d.delay }}
        >
          <Sprite
            name={d.name}
            fw={(d as { fw?: number }).fw ?? 256}
            scale={d.scale}
            startFrame={d.startFrame}
          />
        </motion.div>
      ))}
    </div>
  );
}
